import { Input, Select } from "antd";
import { t } from "i18next";
import { Trans } from "react-i18next";
import { SelectLanguage } from "@components/SelectLanguage/SelectLanguage";
import { IconArrowDown } from "@icons/index";
import { useAppSelector } from "@hooks/redux";
import { ProductToPromoteSection } from "./ProductToPromoteSection";
import { OnCameraCharactersSection } from "./CharacterSelectTrigger";
import { StudioSectionLabel } from "./StudioSectionLabel";
import { useVideoRemakeStudio, VIDEO_REMAKE_PROMPT_MAX } from "./VideoRemakeStudioContext";

const { TextArea } = Input;

export const VideoRemakeStudioForm = () => {
  const { sellingCountry: sellingCountryOptions } = useAppSelector((state) => state.configReducer);
  const { sellingCountry, setSellingCountry, language, setLanguage, customInstructions, setCustomInstructions } =
    useVideoRemakeStudio();

  return (
    <div className="flex flex-col gap-[16px] p-[24px]">
      <ProductToPromoteSection />
      <section className="flex w-full gap-[16px]">
        <div className="flex min-w-0 flex-1 flex-col gap-[4px]">
          <StudioSectionLabel required tooltip={t("Select the region you are selling to.")}>
            <Trans>Target Market</Trans>
          </StudioSectionLabel>
          <Select
            value={sellingCountry || undefined}
            onChange={setSellingCountry}
            placeholder={t("Select the region you are selling to...")}
            className="h-[32px] w-full [&_.ant-select-selector]:!h-[32px] [&_.ant-select-selector]:!items-center"
            options={sellingCountryOptions.map((r) => ({ label: t(r.label), value: r.name ?? r.value }))}
            suffixIcon={<IconArrowDown className="h-[16px] w-[16px] text-kds-fg-subtle" />}
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-[4px]">
          <StudioSectionLabel tooltip={t("Language for voiceovers and model speech.")}>
            <Trans>Language</Trans>
          </StudioSectionLabel>
          <SelectLanguage
            value={language}
            onChange={(v) => setLanguage(v ?? "")}
            className="h-[32px] w-full [&_.ant-select-selector]:!h-[32px]"
          />
        </div>
      </section>

      <section className="flex w-full flex-col gap-[4px]">
        <StudioSectionLabel tooltip={t("Optional notes for highlights or things to avoid in the video.")}>
          <Trans>Custom Instructions</Trans>
        </StudioSectionLabel>
        <TextArea
          value={customInstructions}
          onChange={(e) => setCustomInstructions(e.target.value)}
          placeholder={t("Any special requests? (e.g., specific scenes, style, or things to avoid)")}
          maxLength={VIDEO_REMAKE_PROMPT_MAX}
          showCount
          className="!h-[180px] resize-none border-kds-border-solid bg-kds-bg-element shadow-[0px_1px_1.5px_0px_var(--kds-shadow)]"
          style={{ resize: "none" }}
        />
      </section>

      <OnCameraCharactersSection />
    </div>
  );
};
